export default __webpack_public_path__ + "static/media/js-icon.70e1505e.png";